import {utils} from "./utils";

const activeLang = document.querySelector('.lang-selector__lang--active');
const langList   = document.querySelector('.lang-selector__list');
/*
if (activeLang !== null)
{
	activeLang.addEventListener('click', function () {
		utils.slideToggle(this.nextElementSibling);
		utils.toggleClasses(this.parentNode, 'lang-selector--active');
	});
}*/

/**
 * Language switcher
 */

if (activeLang !== null)
{
	activeLang.addEventListener('click', function () {
		this.parentNode.classList.toggle('lang-selector--active');
	});

	langList.addEventListener('mouseleave', function () {
		this.parentNode.classList.remove('lang-selector--active');
	});
}

